import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  getZone (obj, header, success, error) {
    Vue.axios.post(URL + 'homezone/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSearchReceive (obj, header, success, error) {
    Vue.axios.post(URL + 'receive/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addReceive (obj, header, success, error) {
    Vue.axios.post(URL + 'receive', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReceiveDetail (obj, header, success, error) {
    Vue.axios.get(URL + 'receive/' + obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  calCentralhome (obj, header, success, error) {
    Vue.axios.post(URL + 'receive/homedetail', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  genOtherReceive (obj, header, success, error) {
    Vue.axios.post(URL + 'receive/otherpay', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  genAdvanReceive (obj, header, success, error) {
    Vue.axios.post(URL + 'receive/prepay', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  genFirstPayReceive (obj, header, success, error) {
    Vue.axios.post(URL + 'receive/firstpay', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  disabledReceive (obj, header, success, error) {
    Vue.axios.post(URL + 'receive/disable', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editReceiveDate (obj, header, success, error) {
    Vue.axios.put(URL + 'receive/receive', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_receive.js